module.exports = __webpack_public_path__ + "ad782972845824601dd32bd6dfb7bd6c.png";